import React, { useState } from "react";
import MarketingPage from "./MarketingPage";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ first_name:"", last_name:"", email:"", company:"", company_size:"", industry:"", message:"" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/leads", form); setSent(true); toast.success("Thanks — our team will be in touch."); }
    catch { toast.error("Could not send your enquiry. Try again."); }
    finally { setBusy(false); }
  };
  return (
    <MarketingPage eyebrow="Contact" title="Talk to sales." subtitle="Tell us about your documentation environment and we'll be in touch." cta={false}>
      <div className="max-w-2xl mx-auto fx-panel p-8">
        {sent ? (
          <div className="text-center py-8">
            <div className="font-display text-xl font-semibold text-slate-100">Enquiry received.</div>
            <div className="text-slate-400 mt-2 text-sm">A member of the Fexidoc team will contact you shortly.</div>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
            <div className="grid md:grid-cols-2 gap-4">
              <Input label="First name" value={form.first_name} onChange={(v)=>setForm({...form, first_name:v})} testid="contact-first-name" required/>
              <Input label="Last name" value={form.last_name} onChange={(v)=>setForm({...form, last_name:v})} testid="contact-last-name" required/>
            </div>
            <Input label="Work email" type="email" value={form.email} onChange={(v)=>setForm({...form, email:v})} testid="contact-email" required/>
            <Input label="Company" value={form.company} onChange={(v)=>setForm({...form, company:v})} testid="contact-company" required/>
            <div className="grid md:grid-cols-2 gap-4">
              <Input label="Company size" value={form.company_size} onChange={(v)=>setForm({...form, company_size:v})} testid="contact-size"/>
              <Input label="Industry" value={form.industry} onChange={(v)=>setForm({...form, industry:v})} testid="contact-industry"/>
            </div>
            <label className="block">
              <div className="text-xs text-slate-400 mb-1">Message</div>
              <textarea rows={5} value={form.message} onChange={(e)=>setForm({...form, message:e.target.value})} className="w-full bg-[#0D1224] border border-[#1E293B] rounded-lg px-3 py-2 text-sm text-slate-100 focus:border-cyan-400 outline-none" data-testid="contact-message"/>
            </label>
            <button disabled={busy} type="submit" className="fx-btn-primary text-white font-medium px-5 py-2.5 rounded-lg w-full disabled:opacity-60" data-testid="contact-submit">{busy?"Sending…":"Send enquiry"}</button>
          </form>
        )}
      </div>
    </MarketingPage>
  );
}

function Input({label, value, onChange, type="text", required, testid}) {
  return (
    <label className="block">
      <div className="text-xs text-slate-400 mb-1">{label}</div>
      <input required={required} type={type} value={value} onChange={(e)=>onChange(e.target.value)} className="w-full bg-[#0D1224] border border-[#1E293B] rounded-lg px-3 py-2 text-sm text-slate-100 focus:border-cyan-400 outline-none" data-testid={testid}/>
    </label>
  );
}
